  import firebase from 'firebase'
  
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyAKj9RsNApFnsynFySFGqvBRCMcCg7u1VU",
    authDomain: "lashinstyle-4a027.firebaseapp.com",
    databaseURL: "https://lashinstyle-4a027.firebaseio.com",
    projectId: "lashinstyle-4a027",
    storageBucket: "lashinstyle-4a027.appspot.com",
    messagingSenderId: "727291847979",
    appId: "1:727291847979:web:f4eff42612c10a26"
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const fb = { 
    db: firebase.firestore(),
    auth: firebase.auth(),
    functions: firebase.functions(),
    storage: firebase.storage()
  }

  export default fb;
